import React, { useMemo, useState } from "react";
import { ProjectList } from "./ProjectList";
import projects from "../data/projects";
import { useNavigate } from "react-router-dom";
import { useUserPreference } from "../contexts/UserPreferenceContext";

const ALLOWED_CATEGORIES = ["Hardware", "Software", "UX Design"];

const getCategories = (p) => {
  if (Array.isArray(p.categories)) return p.categories;
  if (Array.isArray(p.category)) return p.category;
  if (typeof p.category === "string") return [p.category];
  return [];
};

function Projects() {
  const { defaultProjectCategory } = useUserPreference();
  const [selectedCategory, setSelectedCategory] = useState(defaultProjectCategory);
  const navigate = useNavigate();

  const handleProjectClick = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  const categoriesFiltered = useMemo(() => {
    const present = ALLOWED_CATEGORIES.filter((cat) =>
      projects.some((p) => getCategories(p).includes(cat))
    );
    return ["All", ...present];
  }, []);

  const filteredProjects = useMemo(() => {
    if (selectedCategory === "All") return projects;
    return projects.filter((p) => getCategories(p).includes(selectedCategory));
  }, [selectedCategory]);

  return (
    <div className="relative transition-colors duration-300">
    <div className="container mx-auto px-4 py-12 ">
      <h1 className="text-4xl font-bold text-gray-800 dark:text-white text-center mb-8">
        Projects
      </h1>

      <div className="flex flex-wrap justify-center gap-3 mb-8">
        {categoriesFiltered.map((category) => {
          const isActive = selectedCategory === category;
          return (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              aria-pressed={isActive}
              className={[
                "px-4 py-2 rounded-full text-sm font-medium transition-colors",
                isActive
                  ? "bg-blue-600 text-white hover:bg-blue-700 dark:hover:bg-blue-600"
                  : "bg-gray-200 text-gray-700 hover:bg-blue-100 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600",
              ].join(" ")}
            >
              {category}
            </button>
          );
        })}
      </div>

      {filteredProjects.length > 0 ? (
        <ProjectList
          projects={filteredProjects}
          onProjectClick={handleProjectClick}
        />
      ) : (
        <p className="text-center text-gray-600 dark:text-gray-300">
          No projects found in{" "}
          <span className="font-semibold">{selectedCategory}</span>.
        </p>
      )}
    </div>
    </div>
  );
}

export default Projects;
